import type { ReactNode } from 'react'

// One stat card as both webhook summaries draw them, and the grid they sit in.

export const TILE_GRID = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(196px, 1fr))',
  gap: 16,
} as const

export const StatTile = ({
  hint,
  label,
  tone = 'neutral',
  value,
}: {
  hint: string
  label: string
  tone?: 'neutral' | 'danger'
  value: ReactNode
}) => (
  <div
    style={{
      minWidth: 0,
      padding: '18px 20px 20px',
      background: 'var(--curri-canvas)',
      border: '1px solid var(--curri-border)',
      borderRadius: 'var(--curri-radius-lg)',
    }}
  >
    <div
      style={{
        fontSize: 11,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: 'var(--curri-text-tertiary)',
      }}
    >
      {label}
    </div>
    <div
      style={{
        marginTop: 12,
        fontSize: 32,
        fontWeight: 700,
        lineHeight: 1,
        fontVariantNumeric: 'tabular-nums',
        letterSpacing: '-0.02em',
        color:
          tone === 'danger' ? 'var(--color-text-danger)' : 'var(--curri-text)',
      }}
    >
      {value}
    </div>
    <div
      style={{
        marginTop: 10,
        fontFamily: 'var(--curri-font-mono)',
        fontSize: 11,
        letterSpacing: '0.04em',
        color: 'var(--curri-text-tertiary)',
      }}
    >
      {hint}
    </div>
  </div>
)
